import { render, staticRenderFns } from "./DictionaryGeneralEffects.vue?vue&type=template&id=c2f3bcca&scoped=true&"
import script from "./DictionaryGeneralEffects.vue?vue&type=script&lang=js&"
export * from "./DictionaryGeneralEffects.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryGeneralEffects.vue?vue&type=style&index=0&id=c2f3bcca&scoped=true&lang=scss&"
import style1 from "./DictionaryGeneralEffects.vue?vue&type=style&index=1&id=c2f3bcca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f3bcca",
  null
  
)

export default component.exports